import { render, staticRenderFns } from "./DetailSupport.vue?vue&type=template&id=2633064d&"
import script from "./DetailSupport.vue?vue&type=script&lang=js&"
export * from "./DetailSupport.vue?vue&type=script&lang=js&"
import style0 from "./DetailSupport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports